// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3um-f","header":"PatientBlock_header__b_0RH","label":"PatientBlock_label__22-eF","option":"PatientBlock_option__1gSFg"};